export default "__VITE_ASSET__5105d4e3__"